"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.media = exports.breakpoints = void 0;
const styled_components_1 = require("styled-components");
exports.breakpoints = {
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1920,
};
exports.media = Object.keys(exports.breakpoints).reduce((acc, label) => {
    acc[label] = (first, ...interpolations) => (0, styled_components_1.css) `
    @media (min-width: ${exports.breakpoints[label] / 16}em) {
      ${(0, styled_components_1.css)(first, ...interpolations)}
    }
  `;
    return acc;
}, {});
exports.default = exports.breakpoints;
//# sourceMappingURL=breakpoints.js.map